import { render, staticRenderFns } from "./PayPage.vue?vue&type=template&id=397a7e7a"
import script from "./PayPage.vue?vue&type=script&lang=js"
export * from "./PayPage.vue?vue&type=script&lang=js"
import style0 from "./PayPage.vue?vue&type=style&index=0&id=397a7e7a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports